import React, { useState } from "react";
import ProfileAvatar from "../../../components/globalFunctions/globalFunctions";
import CustomModal from "../../../components/customModal/customModal";
import "./../students.css";
import { Dropdown } from "primereact/dropdown";

const AllStudents = () => {
  const studentList = [
    {
      studentId: "STU001",
      fullName: "John Carter",
      email: "john.carter@example.com",
      phone: "+1-555-222-0101",
      lmsSource: "Moodle",
      enrolledCoursesCount: 5,
      completionPercentage: 78,
      lastActivityDate: "2025-01-20",
      status: "Active",
    },
    {
      studentId: "STU002",
      fullName: "Emily Watson",
      email: "emily.watson@example.com",
      phone: "+1-555-222-0102",
      lmsSource: "Canvas",
      enrolledCoursesCount: 3,
      completionPercentage: 92,
      lastActivityDate: "2025-01-18",
      status: "Active",
    },
    {
      studentId: "STU003",
      fullName: "Michael Brown",
      email: "michael.brown@example.com",
      phone: "+1-555-222-0103",
      lmsSource: "Blackboard",
      enrolledCoursesCount: 4,
      completionPercentage: 65,
      lastActivityDate: "2025-01-15",
      status: "Active",
    },
    {
      studentId: "STU004",
      fullName: "Sophia Johnson",
      email: "sophia.johnson@example.com",
      phone: "+1-555-222-0104",
      lmsSource: "Moodle",
      enrolledCoursesCount: 6,
      completionPercentage: 88,
      lastActivityDate: "2025-01-22",
      status: "Active",
    },
    {
      studentId: "STU005",
      fullName: "Daniel Lee",
      email: "daniel.lee@example.com",
      phone: "+1-555-222-0105",
      lmsSource: "Canvas",
      enrolledCoursesCount: 2,
      completionPercentage: 40,
      lastActivityDate: "2025-01-10",
      status: "Inactive",
    },
    {
      studentId: "STU006",
      fullName: "Olivia Martinez",
      email: "olivia.martinez@example.com",
      phone: "+1-555-222-0106",
      lmsSource: "Blackboard",
      enrolledCoursesCount: 7,
      completionPercentage: 95,
      lastActivityDate: "2025-01-25",
      status: "Completed",
    },
    {
      studentId: "STU007",
      fullName: "William Anderson",
      email: "william.anderson@example.com",
      phone: "+1-555-222-0107",
      lmsSource: "Moodle",
      enrolledCoursesCount: 1,
      completionPercentage: 20,
      lastActivityDate: "2025-01-05",
      status: "Inactive",
    },
    {
      studentId: "STU008",
      fullName: "Ava Thompson",
      email: "ava.thompson@example.com",
      phone: "+1-555-222-0108",
      lmsSource: "Canvas",
      enrolledCoursesCount: 4,
      completionPercentage: 70,
      lastActivityDate: "2025-01-19",
      status: "Active",
    },
    {
      studentId: "STU009",
      fullName: "James Wilson",
      email: "james.wilson@example.com",
      phone: "+1-555-222-0109",
      lmsSource: "Blackboard",
      enrolledCoursesCount: 3,
      completionPercentage: 55,
      lastActivityDate: "2025-01-14",
      status: "Active",
    },
    {
      studentId: "STU010",
      fullName: "Isabella Moore",
      email: "isabella.moore@example.com",
      phone: "+1-555-222-0110",
      lmsSource: "Moodle",
      enrolledCoursesCount: 5,
      completionPercentage: 83,
      lastActivityDate: "2025-01-21",
      status: "Active",
    },
    {
      studentId: "STU011",
      fullName: "Benjamin Taylor",
      email: "benjamin.taylor@example.com",
      phone: "+1-555-222-0111",
      lmsSource: "Canvas",
      enrolledCoursesCount: 6,
      completionPercentage: 90,
      lastActivityDate: "2025-01-23",
      status: "Active",
    },
    {
      studentId: "STU012",
      fullName: "Mia Harris",
      email: "mia.harris@example.com",
      phone: "+1-555-222-0112",
      lmsSource: "Blackboard",
      enrolledCoursesCount: 2,
      completionPercentage: 35,
      lastActivityDate: "2025-01-08",
      status: "Inactive",
    },
    {
      studentId: "STU013",
      fullName: "Lucas Clark",
      email: "lucas.clark@example.com",
      phone: "+1-555-222-0113",
      lmsSource: "Moodle",
      enrolledCoursesCount: 8,
      completionPercentage: 97,
      lastActivityDate: "2025-01-26",
      status: "Completed",
    },
    {
      studentId: "STU014",
      fullName: "Charlotte Lewis",
      email: "charlotte.lewis@example.com",
      phone: "+1-555-222-0114",
      lmsSource: "Canvas",
      enrolledCoursesCount: 3,
      completionPercentage: 60,
      lastActivityDate: "2025-01-16",
      status: "Active",
    },
    {
      studentId: "STU015",
      fullName: "Henry Walker",
      email: "henry.walker@example.com",
      phone: "+1-555-222-0115",
      lmsSource: "Blackboard",
      enrolledCoursesCount: 4,
      completionPercentage: 72,
      lastActivityDate: "2025-01-17",
      status: "Active",
    },
    {
      studentId: "STU016",
      fullName: "Amelia Hall",
      email: "amelia.hall@example.com",
      phone: "+1-555-222-0116",
      lmsSource: "Moodle",
      enrolledCoursesCount: 5,
      completionPercentage: 85,
      lastActivityDate: "2025-01-24",
      status: "Active",
    },
    {
      studentId: "STU017",
      fullName: "Ethan Allen",
      email: "ethan.allen@example.com",
      phone: "+1-555-222-0117",
      lmsSource: "Canvas",
      enrolledCoursesCount: 2,
      completionPercentage: 45,
      lastActivityDate: "2025-01-11",
      status: "Inactive",
    },
    {
      studentId: "STU018",
      fullName: "Harper Young",
      email: "harper.young@example.com",
      phone: "+1-555-222-0118",
      lmsSource: "Blackboard",
      enrolledCoursesCount: 6,
      completionPercentage: 89,
      lastActivityDate: "2025-01-22",
      status: "Active",
    },
    {
      studentId: "STU019",
      fullName: "Noah King",
      email: "noah.king@example.com",
      phone: "+1-555-222-0119",
      lmsSource: "Moodle",
      enrolledCoursesCount: 1,
      completionPercentage: 15,
      lastActivityDate: "2025-01-03",
      status: "Inactive",
    },
    {
      studentId: "STU020",
      fullName: "Lily Scott",
      email: "lily.scott@example.com",
      phone: "+1-555-222-0120",
      lmsSource: "Canvas",
      enrolledCoursesCount: 7,
      completionPercentage: 93,
      lastActivityDate: "2025-01-25",
      status: "Active",
    },
  ];

  const options = [
    { name: "Option 1", val: 0 },
    { name: "Option 2", val: 1 },
    { name: "Option 3", val: 2 },
  ];

  const statusType = [
    { name: "Active", val: 0 },
    { name: "Inactive", val: 1 },
    { name: "Alumni", val: 2 },
  ];
  const [selectedOption, setSelectedOption] = useState(null);

  const [selectedIds, setSelectedIds] = useState([]);
  const [viewStudents, setViewStudents] = useState([]);
  const [getModalLayout, setGetModalLayout] = useState(null);
  const [activityTab, setActivityTab] = useState(1);

  const handleRowSelect = (e, id) => {
    if (e.target.checked) {
      setSelectedIds((prev) => [...prev, id]);
    } else {
      setSelectedIds((prev) => prev.filter((item) => item !== id));
    }
  };

  // Refresh
  const handleRefresh = () => {
    setSelectedIds([]);
    setViewStudents([]);
  };

  // Open modal
  const handleViewStudent = (student) => {
    const exists = viewStudents.find((item) => item.studentId === student.studentId);
    if (!exists) {
      setViewStudents((prev) => [...prev, student]);
    }
  };

  // Close modal
  const handleCloseModal = (studentId) => {
    setViewStudents((prev) => prev.filter((item) => item.studentId !== studentId));
  };

  const renderStudentDetails = (student) => {
    const { id, fullName, phone, email, message, enrolledCoursesCount, tour_time, updated_at, type } = student;

    return (
      <>
        <div id="popupSidebar" className="popup-sidebar" style={{ backgroundColor: "#f2f2f2" }}>
          <div className="popup-menu">
            <button
              onClick={() => {
                setActivityTab(1);
              }}
              className={activityTab === 1 ? "activityInfo-button active" : "activityInfo-button"}
            >
              <i className="ri-info-card-line"></i>
              <span>{fullName}'s Profile</span>
            </button>
            <button
              onClick={() => {
                setActivityTab(2);
              }}
              className={activityTab === 2 ? "activityInfo-button active" : "activityInfo-button"}
            >
              <i className="ri-school-line"></i>
              <span>Academic Information</span>
            </button>
            <button
              onClick={() => {
                setActivityTab(3);
              }}
              className={activityTab === 3 ? "activityInfo-button active" : "activityInfo-button"}
            >
              <i className="ri-bar-chart-box-line"></i>
              <span>Detailed Course Performance</span>
            </button>
            <button
              onClick={() => {
                setActivityTab(4);
              }}
              className={activityTab === 4 ? "activityInfo-button active" : "activityInfo-button"}
            >
              <i className="ri-pie-chart-box-line"></i>
              <span>Course Enrollment Summary</span>
            </button>
            <button
              onClick={() => {
                setActivityTab(5);
              }}
              className={activityTab === 5 ? "activityInfo-button active" : "activityInfo-button"}
            >
              <i className="ri-verified-badge-line"></i>
              <span>Certification Records</span>
            </button>
          </div>

          {/* <div className="lead-sidebar">
            <ul>
              <li>
                <span>Name</span> {fullName}
              </li>
              <li>
                <span>Phone</span> <a href="">{phone}</a>
              </li>
              <li>
                <span>Email</span> <a href="">{email}</a>
              </li>
            </ul>
            <div className="des">
              <span>Description</span> <p>{message}</p>
            </div>
          </div> */}
        </div>
        <div id="popupContentGrid" className="popup-content-grid">
          <div id="popupContentGrid" className="student-popup-content">
            {activityTab === 1 && (
              <>
                {/* <h4>Company Profile</h4> */}
                <div className="form-group-grid">
                  <div className="form-group">
                    <label className="form-label">Learner ID </label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Registration Number</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Full Name </label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Profile Photo </label>
                    <input type="file" className="form-control form-control-upload" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Email Address (University Email) </label>
                    <input type="email" className="form-control" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Mobile Number </label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Date of Birth </label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Gender </label>
                    <Dropdown
                      value={selectedOption}
                      onChange={(e) => setSelectedOption(e.value)}
                      options={options}
                      optionLabel="name"
                      optionValue="val"
                      appendTo="self"
                      className="customised-dropdown"
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Nationality</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Student Status </label>
                    <Dropdown
                      value={selectedOption}
                      onChange={(e) => setSelectedOption(e.value)}
                      options={statusType}
                      optionLabel="name"
                      optionValue="val"
                      appendTo="self"
                      className="customised-dropdown"
                    />
                  </div>
                </div>
              </>
            )}
            {activityTab === 2 && (
              <>
                {/* <h4>Company Profile</h4> */}
                <div className="form-group-grid">
                  <div className="form-group">
                    <label className="form-label">University Name </label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">College / School</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Department </label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Program / Degree </label>
                    <input type="file" className="form-control form-control-upload" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Specialization / Major </label>
                    <input type="email" className="form-control" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Academic Year </label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Batch / Cohort </label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Semester / Term </label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Enrollment Date</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Expected Graduation Year</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Credit Requirement </label>
                    <Dropdown
                      value={selectedOption}
                      onChange={(e) => setSelectedOption(e.value)}
                      options={options}
                      optionLabel="name"
                      optionValue="val"
                      appendTo="self"
                      className="customised-dropdown"
                    />
                  </div>
                </div>
              </>
            )}
            {activityTab === 3 && (
              <div className="table-responsive student-table">
                <table className="table align-middle text-nowrap table-hover table-small">
                  <thead className="bg-light-subtle">
                    <tr>
                      <th>Course Title</th>
                      <th>Start Date</th>
                      <th>Completion Date</th>
                      <th>Progress Percentage</th>
                      <th>Assessment Scores</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>HTML & CSS Fundamentals</td>
                      <td>01 Jan 2026</td>
                      <td>15 Jan 2026</td>
                      <td>100%</td>
                      <td>92%</td>
                      <td>Completed</td>
                    </tr>

                    <tr>
                      <td>JavaScript Basics</td>
                      <td>05 Jan 2026</td>
                      <td>—</td>
                      <td>75%</td>
                      <td>68%</td>
                      <td>In Progress</td>
                    </tr>

                    <tr>
                      <td>React.js Essentials</td>
                      <td>10 Jan 2026</td>
                      <td>—</td>
                      <td>45%</td>
                      <td>—</td>
                      <td>In Progress</td>
                    </tr>

                    <tr>
                      <td>UI/UX Design Principles</td>
                      <td>20 Dec 2025</td>
                      <td>05 Jan 2026</td>
                      <td>100%</td>
                      <td>88%</td>
                      <td>Completed</td>
                    </tr>

                    <tr>
                      <td>Advanced Web Performance</td>
                      <td>25 Jan 2026</td>
                      <td>—</td>
                      <td>10%</td>
                      <td>—</td>
                      <td>Not Started</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
            {activityTab === 4 && (
              <form className="custom-editable-form">
                <div className="form-group-grid">
                  <div className="form-group">
                    <label className="form-label">Total Courses Enrolled</label>
                    <input type="text" className="form-control" value={5} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Courses In Progress</label>
                    <input type="text" className="form-control" value={2} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Courses Completed</label>
                    <input type="text" className="form-control" value={2} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Courses Dropped / Incomplete</label>
                    <input type="text" className="form-control" value={1} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Average Completion Rate</label>
                    <input type="text" className="form-control" value={"40%"} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Last Activity Date</label>
                    <input type="text" className="form-control" value={"26 Jan, 2025"} />
                  </div>
                </div>
              </form>
              // <div className="table-responsive">
              //   <table className="table align-middle text-nowrap table-hover table-small">
              //     <thead className="bg-light-subtle">
              //       <tr>
              //         <th>Total Courses Enrolled</th>
              //         <th>Courses In Progress</th>
              //         <th>Courses Completed</th>
              //         <th>Courses Dropped / Incomplete</th>
              //         <th>Average Completion Rate</th>
              //         <th>Last Activity Date</th>
              //       </tr>
              //     </thead>
              //     <tbody>
              //       <tr>
              //         <td></td>
              //       </tr>
              //     </tbody>
              //   </table>
              // </div>
            )}
            {activityTab === 5 && (
              <>
                <div className="table-responsive student-table">
                  <table className="table align-middle text-nowrap table-hover table-small">
                    <thead className="bg-light-subtle">
                      <tr>
                        <th>Certificate Title</th>
                        <th>Course completion date</th>
                        <th>Download Certificate (PDF)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>HTML & CSS Fundamentals</td>
                        <td>15 Jan 2026</td>
                        <td>
                          <a>
                            <i class="ri-download-2-line"></i>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>UI/UX Design Principles</td>
                        <td>05 Jan 2026</td>
                        <td>
                          <a>
                            <i class="ri-download-2-line"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        </div>
      </>
    );
  };

  const renderView = () => {
    return studentList.map((student) => (
      <tr key={student.studentId}>
        <td style={{ width: "10px", paddingRight: "0" }}>
          <div className="form-check">
            <input type="checkbox" className="form-check-input" checked={selectedIds.includes(student.studentId)} onChange={(e) => handleRowSelect(e, student.studentId)} />
          </div>
        </td>
        <td>
          <div className="d-flex align-items-center user-title">
            <i className="profile-pic">
              <ProfileAvatar name={student.fullName} />
            </i>
            <button
              className="student-name"
              onClick={() => {
                return (handleViewStudent(student), setActivityTab(1));
              }}
            >
              {student.fullName}
            </button>
          </div>
        </td>
        <td>
          <a href={`mailto:${student.email}`}>{student.email}</a>
        </td>
        <td>
          <a href={`tel:${student.phone}`}>{student.phone}</a>
        </td>
        <td style={{ paddingLeft: "25px" }}>{student.enrolledCoursesCount}</td>
        <td>
          {student.status}
          {/* <span className={`badge ${student.status === "Active" ? "bg-success" : student.status === "Completed" ? "bg-warning" : student.status === "Inactive" ? "bg-primary" : "bg-secondary"}`}>
            {student.status}
          </span> */}
        </td>
        <td>{student.lastActivityDate}</td>
      </tr>
    ));
  };

  return (
    <div className="page-content student-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0">Learners List ({studentList.length})</h4>
              <div className="page-title-box-content">
                {selectedIds.length > 0 && (
                  <>
                    {selectedIds.length === 1 && (
                      <button className="page-title-box-btn">
                        <i className="ri-edit-line"></i>
                      </button>
                    )}
                    <button className="page-title-box-btn">
                      <i className="ri-delete-bin-line"></i>
                    </button>
                  </>
                )}
                <button type="button" className="page-title-box-btn" onClick={handleRefresh}>
                  <i className="ri-refresh-line"></i>
                </button>
                <form className="app-search">
                  <div className="position-relative">
                    <input type="search" className="form-control" placeholder="Search..." autoComplete="off" name="searchValue" />
                    <i className="ri-search-line search-widget-icon"></i>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="table-responsive">
                <table className="table align-middle text-nowrap table-hover table-small">
                  <thead className="bg-light-subtle">
                    <tr>
                      <th style={{ width: "10px", paddingRight: "0" }}>
                        <div className="form-check">
                          <input type="checkbox" className="form-check-input" />
                          <label className="form-check-label"></label>
                        </div>
                      </th>
                      <th style={{ width: "500px" }}>Name</th>
                      <th style={{ width: "400px" }}>Email</th>
                      <th style={{ width: "300px" }}>Phone</th>
                      <th>Courses Registered</th>
                      <th>Status</th>
                      <th>Last Activity Date</th>
                    </tr>
                  </thead>
                  <tbody>{renderView()}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="minimize-grid">
        {viewStudents.map((student) => (
          <CustomModal
            key={student.studentId}
            visible={true}
            title="Learner Overview"
            secondaryTitle={student.fullName}
            getModalLayout={setGetModalLayout}
            showLayoutIcon={viewStudents.length === 1}
            onHandleClose={() => handleCloseModal(student.studentId)}
            renderItem={() => renderStudentDetails(student)}
          />
        ))}
      </div>

      {/* <div className="minimize-grid">
        {viewStudent.length >= 1 &&
          viewStudent.map((item) => (
            <CustomModal
              key={item.id}
              renderItem={() => renderStudentDetails(item)}
              title="Lead Overview"
              secondaryTitle={item.client_name}
              getModalLayout={setGetModalLayout}
              visible={true}
              filters={leadFilters}
              showLeftSidebarIcon={true}
              showLayoutIcon={viewStudent.length === 1}
              onHandleClose={() => {
                const modifiedData = viewStudent.filter((lead) => lead.id !== item.id);
                setViewStudent(modifiedData);
                handleReset();
              }}
            />
          ))}
      </div> */}
    </div>
  );
};

export default AllStudents;
